import whenDomReady from 'when-dom-ready';

const ACTIVE = 'active';
const NOT_ACTIVE = 'not-active';

function initialise() {
  const reviews = document.querySelectorAll('.js-review');

  if (reviews.length === 0) {
    return;
  }

  for (let index = 0; index < reviews.length; index += 1) {
    const review = reviews[index];
    const reviewTeaser = review.querySelector('.js-review-teaser');
    const reviewTeaserToggle = review.querySelector('.js-review-teaser-toggle');

    const reviewFull = review.querySelector('.js-review-full');
    const reviewFullToggle = review.querySelector('.js-review-full-toggle');

    if (reviewTeaserToggle) {
      reviewTeaserToggle.addEventListener('click', () => {
        reviewTeaser.classList.add(NOT_ACTIVE);
        reviewFull.classList.add(ACTIVE);
      });
    }

    if (reviewFullToggle) {
      reviewFullToggle.addEventListener('click', () => {
        reviewTeaser.classList.remove(NOT_ACTIVE);
        reviewFull.classList.remove(ACTIVE);
      });
    }
  }
}

whenDomReady().then(initialise);

Sys.WebForms.PageRequestManager.getInstance().add_endRequest(initialise);
